// ===================================================
// PLANO DE CORTE — NESTING (Global multi-projeto)
// Regras de segurança:
// 1. Só entram pedidos aprovados e ainda não cortados (whitelist de status).
// 2. Peças agrupadas por material + espessura — nunca misturar espessuras.
// 3. Dimensão de corte = geometria real (contorno, fundo medido, engaste).
// 4. Sentido do veio trava a rotação da peça no encaixe.
// 5. Plano pode ser salvo, aprovado e ter o corte registrado (rastreável).
// 6. Chapas reais do estoque: retalhos primeiro, reserva na aprovação,
//    baixa automática e sobras viram retalhos ao registrar o corte.
// ===================================================
let _nestingMedicaoId=null;
let _nestingScope='global'; // 'global' | 'medicao'
let _nestingCalcAtual=null;   // último cálculo exibido
let _nestingPlanoAberto=null; // plano salvo em exibição
let _nestingRenderTimer=null;
let _nestingChapasSel=null;   // null = todas as chapas disponíveis
let _nestingChapasKey='';     // material|esp da seleção atual

const NEST_STATUS_CORTE=['aprovado','ag_medicao','medido','projeto','ag_material','em_corte'];
const NEST_PLANO_LABEL={rascunho:'RASCUNHO — aguardando conferência',aprovado:'APROVADO PARA CORTE',cortado:'CORTE REGISTRADO'};
const NEST_SOBRA_MIN=30; // cm — sobra menor que isto não é considerada aproveitável

function nestNum(v){return window.MarmoriaGeometry.num(v)}
function nestUid(pfx){try{return pfx+'_'+crypto.randomUUID().replace(/-/g,'').slice(0,10)}catch(e){return pfx+'_'+Date.now().toString(36)+Math.random().toString(36).slice(2,8)}}
function nestUsuarioAtual(){try{return (typeof firebase!=='undefined'&&firebase.auth&&firebase.auth().currentUser?.email)||'operador local'}catch(e){return 'operador local'}}

function openNestingGlobal(){
  _nestingMedicaoId=null;_nestingScope='global';_nestingPlanoAberto=null;_nestingChapasSel=null;
  document.getElementById('nest-scope').value='global';
  document.getElementById('nest-title').innerHTML='✂️ Plano de Corte — Todos os Pedidos <button class="modal-close" onclick="closeModal(\'modal-nesting\')">×</button>';
  nestingTravarCampos(false);
  _nestingAtualizarMateriais();
  nestingPopularPlanosSalvos();
  openModal('modal-nesting');
}

function openNestingModal(medicaoId){
  const med=(DB.get('medicoes')||[]).find(x=>x.id===medicaoId);
  const liberadas=medicaoResumoTecnico(med).liberadas;
  if(!liberadas){
    toast('Plano de corte bloqueado: nenhuma peça tecnicamente liberada para corte nesta medição.','error');
    return;
  }
  _nestingMedicaoId=medicaoId;_nestingScope='medicao';_nestingPlanoAberto=null;_nestingChapasSel=null;
  document.getElementById('nest-scope').value='medicao';
  const m=(CACHE.medicoes||[]).find(x=>x.id===medicaoId);
  document.getElementById('nest-title').innerHTML=`✂️ Plano de Corte — ${escapeHtml(m?.cliente||'Medição')} <button class="modal-close" onclick="closeModal('modal-nesting')">×</button>`;
  nestingTravarCampos(false);
  _nestingAtualizarMateriais();
  nestingPopularPlanosSalvos();
  openModal('modal-nesting');
}

// A estação separada é de leitura/conferência e pode ser aberta mesmo com
// pendências. Assim a equipe vê exatamente o que falta antes de editar o plano.
function abrirEstacaoNesting(medicaoId){
  const med=(DB.get('medicoes')||[]).find(m=>m.id===medicaoId);
  if(!med){toast('Medição não encontrada.','error');return}
  location.href=`nesting.html?medicaoId=${encodeURIComponent(medicaoId)}`;
}

function _nestingAtualizarMateriais(){
  const scope=document.getElementById('nest-scope').value;
  _nestingScope=scope;
  const matSel=document.getElementById('nest-material');
  const prev=matSel.value;
  const mats=new Set();
  if(scope==='medicao'&&_nestingMedicaoId){
    const m=(CACHE.medicoes||[]).find(x=>x.id===_nestingMedicaoId);
    (m?.ambientes||[]).forEach(a=>(a.pecas||[]).forEach(p=>{if(p.material)mats.add(String(p.material).trim());}));
  } else {
    const medicoes=CACHE.medicoes||[];
    DB.get('pedidos').forEach(p=>{
      if(!NEST_STATUS_CORTE.includes(p.status)) return;
      const med=p.medicaoId?medicoes.find(m=>m.id===p.medicaoId):null;
      if(med){(med.ambientes||[]).forEach(a=>(a.pecas||[]).forEach(pc=>{if(pc.material)mats.add(String(pc.material).trim());}));}
      else {(p.itens||[]).forEach(it=>{if(it.material)mats.add(String(it.material).trim());});if(p.material)mats.add(String(p.material).trim());}
    });
  }
  matSel.innerHTML='<option value="">— Selecione o material —</option>'+[...mats].sort().map(m=>`<option value="${escapeHtml(m)}"${m===prev?' selected':''}>${escapeHtml(m)}</option>`).join('');
  if(![...mats].includes(prev)) matSel.value='';
  if(!matSel.value&&mats.size>0) matSel.value=[...mats].sort()[0];
  nestingAtualizarVeioDoCatalogo();
  renderNestingPlano();
}

// Sentido do veio vem do catálogo de pedras. Sem cadastro → travado (seguro).
function nestingAtualizarVeioDoCatalogo(){
  const material=document.getElementById('nest-material')?.value||'';
  const sel=document.getElementById('nest-veio');
  if(!sel) return;
  if(!material){sel.value='travar';return;}
  const pedra=(CACHE.pedras||[]).find(p=>String(p.nome||'').trim().toLowerCase()===material.toLowerCase());
  sel.value=pedra?(pedra.temVeio===false?'livre':'travar'):'travar';
}

// Extrai TODAS as peças cortáveis do material (todas as espessuras).
function extrairPecasGlobal(material){
  const pecas=[];let seq=0;
  const medicoes=CACHE.medicoes||[];
  function addPeca(base,tipo,w,h,extra){
    if(!(w>0&&h>0)) return;
    seq++;
    pecas.push({...base,...(extra||{}),id:`${tipo[0]}${seq}`,tipo,w:Math.round(w*10)/10,h:Math.round(h*10)/10});
  }
  function processarMed(med,pedido){
    const pNum=pedido?.num||(pedido?.id||'').slice(-4);
    const pCliente=pedido?.cliente||med.cliente||'—';
    const medAprovada=med.status==='aprovada';
    (med.ambientes||[]).forEach(amb=>{
      (amb.pecas||[]).forEach(p=>{
        if(String(p.material||'').trim()!==material) return;
        const g=p.geometria,liberada=p.statusPeca==='liberada_corte'&&g?.bloqueadaEdicao===true;
        const qtd=Math.max(1,parseInt(p.qtd||1)||1);
        const esp=nestNum(p.esp)||2;
        const corte=window.MarmoriaGeometry.cutRectangle(p);
        for(let q=0;q<qtd;q++){
          const base={uid:p.uid||null,pedidoId:pedido?.id||med.id,pedidoNum:pNum,cliente:pCliente,ambiente:amb.nome||'—',nome:p.nome||'Peça',material,esp,medicaoId:med.id,medAprovada};
          addPeca(base,'tampo',corte.w,corte.h,{foraEsquadro:corte.foraEsquadro,engaste:corte.engaste,semDesenho:!g,naoLiberada:!liberada,revisao:p.revisaoTecnica||g?.revisao||0});
          if(!g) continue;
          const rod=nestNum(g.rodabanca);
          const comp=Math.max(nestNum(p.comp),nestNum(g.frente),nestNum(g.fundo));
          if(rod>0) addPeca({...base,nome:'Rodabanca · '+base.nome},'rodabanca',comp,rod);
          if((g.saiaTrechos||[]).length){
            g.saiaTrechos.forEach((t,ti)=>{
              const tw=nestNum(t.fim)-nestNum(t.inicio),th=nestNum(t.altura);
              addPeca({...base,nome:`Saia T${ti+1} · ${base.nome}`},'saia',tw,th);
            });
          } else {
            const saia=nestNum(g.saia);
            if(saia>0) addPeca({...base,nome:'Saia · '+base.nome},'saia',comp,saia);
          }
          (g.pes||[]).filter(pe=>pe.ativo!==false).forEach((pe,pei)=>{const ph=nestNum(pe.altura),pw=nestNum(pe.profundidade)||nestNum(g.esquerda)||nestNum(p.larg);if(ph>0&&pw>0)addPeca({...base,nome:`Pé ${pei+1} · ${base.nome}`},'pe',pw,ph)});
        }
      });
    });
  }
  if(_nestingScope==='medicao'&&_nestingMedicaoId){
    const med=medicoes.find(m=>m.id===_nestingMedicaoId);
    if(med){
      const pedido=med.pedidoId?DB.get('pedidos').find(p=>p.id===med.pedidoId):null;
      processarMed(med,pedido);
    }
  } else {
    DB.get('pedidos').forEach(p=>{
      if(!NEST_STATUS_CORTE.includes(p.status)) return;
      const med=p.medicaoId?medicoes.find(m=>m.id===p.medicaoId):null;
      if(med){processarMed(med,p);}
      else {
        (p.itens||[]).forEach(it=>{
          if(String(it.material||'').trim()!==material) return;
          const qtd=Math.max(1,parseInt(it.qtd||1)||1);
          const comp=nestNum(it.comp),larg=nestNum(it.larg);
          const esp=nestNum(it.esp)||2;
          for(let q=0;q<qtd;q++){
            addPeca({uid:null,pedidoId:p.id,pedidoNum:p.num||(p.id||'').slice(-4),cliente:p.cliente||'—',ambiente:'—',nome:it.descricao||it.tipo||'Item',material,esp,medicaoId:null,medAprovada:false},'tampo',comp,larg,{semDesenho:true});
          }
        });
      }
    });
  }
  return pecas;
}

function nestingAssinatura(pieces){
  return pieces.map(p=>`${p.uid||p.nome}|${p.tipo}|${p.w.toFixed(1)}x${p.h.toFixed(1)}x${p.esp}`).sort().join('§');
}

function nestingCalc(pieces,slabW,slabH,kerf){
  return window.MarmoriaGeometry.packRectangles(pieces,slabW,slabH,kerf);
}

// Empacotamento em chapas reais (dimensões heterogêneas): preenche cada
// chapa na ordem recebida (retalhos primeiro) e passa o restante adiante.
function nestingCalcChapasReais(pieces,chapas,kerf,refilo){
  let restantes=[...pieces];
  const usadas=[];
  chapas.forEach(ch=>{
    if(!restantes.length) return;
    const uw=nestNum(ch.largura)-2*refilo,uh=nestNum(ch.altura)-2*refilo;
    if(!(uw>0&&uh>0)) return;
    const slabs=window.MarmoriaGeometry.packRectangles(restantes,uw,uh,kerf);
    if(!slabs.length) return;
    const placed=slabs[0].placed.filter(p=>!p.overflow);
    if(!placed.length) return;
    const ids=new Set(placed.map(p=>p.id));
    restantes=restantes.filter(p=>!ids.has(p.id));
    usadas.push({chapa:ch,slab:{placed,free:slabs[0].free||[]}});
  });
  return {usadas,restantes};
}

// Sobras aproveitáveis (retângulos livres máximos ≥ NEST_SOBRA_MIN).
// Guardam posição para permitir seleção não sobreposta na baixa.
function nestingSobras(slab){
  return (slab.free||[])
    .filter(r=>r.w>=NEST_SOBRA_MIN&&r.h>=NEST_SOBRA_MIN)
    .sort((a,b)=>b.w*b.h-a.w*a.h)
    .slice(0,4)
    .map(r=>({x:Math.round((r.x||0)*10)/10,y:Math.round((r.y||0)*10)/10,w:Math.floor(r.w*10)/10,h:Math.floor(r.h*10)/10}));
}

// Chapas físicas disponíveis para material + espessura (retalhos primeiro).
function nestingChapasDisponiveis(material,espessura){
  const out=[];
  (DB.get('estoque')||[]).forEach(e=>{
    if(String(e.material||'').trim().toLowerCase()!==String(material||'').trim().toLowerCase()) return;
    if(Math.abs((nestNum(e.espessura)||0)-espessura)>0.01) return;
    (e.chapas||[]).forEach(c=>{
      if(c.status!=='disponivel') return;
      const lw=nestNum(c.largura),lh=nestNum(c.altura);
      if(!(lw>0&&lh>0)) return;
      out.push({estoqueId:e.id,chapaId:c.id,numero:c.numero||'—',largura:lw,altura:lh,m2:c.m2||Math.round(lw*lh/100)/100,retalho:!!c.retalho,custo:nestNum(c.custo)||0});
    });
  });
  out.sort((a,b)=>(a.retalho?0:1)-(b.retalho?0:1)||a.largura*a.altura-b.largura*b.altura);
  return out;
}

function toggleNestChapa(chapaId,on){
  if(!(_nestingChapasSel instanceof Set)) _nestingChapasSel=new Set((_nestingUltimaDisp||[]).map(c=>c.chapaId));
  if(on)_nestingChapasSel.add(chapaId);else _nestingChapasSel.delete(chapaId);
  renderNestingPlano();
}
let _nestingUltimaDisp=[];
function renderNestingChapasLista(disp,selecionadas){
  _nestingUltimaDisp=disp;
  const el=document.getElementById('nest-chapas-lista');if(!el)return;
  if(!disp.length){el.innerHTML='<div style="font-size:11px;color:var(--muted)">Nenhuma chapa disponível deste material/espessura no estoque. Cadastre em Estoque ou use dimensões manuais.</div>';return;}
  el.innerHTML=disp.map(c=>`<label style="display:inline-flex;align-items:center;gap:6px;border:1px solid var(--border);border-radius:8px;padding:5px 10px;font-size:11.5px;cursor:pointer;${selecionadas.has(c.chapaId)?'background:var(--surface2)':''}">
    <input type="checkbox" ${selecionadas.has(c.chapaId)?'checked':''} onchange="toggleNestChapa('${escapeHtml(c.chapaId)}',this.checked)">
    ${c.retalho?'<span style="background:#dcfce7;color:#166534;border-radius:10px;padding:1px 7px;font-size:10px;font-weight:700">RETALHO</span>':''}
    <strong>${escapeHtml(String(c.numero))}</strong> · ${c.largura}×${c.altura} cm · ${c.m2} m²
  </label>`).join(' ');
}

function nestingAgendarRender(){clearTimeout(_nestingRenderTimer);_nestingRenderTimer=setTimeout(renderNestingPlano,250);}

function nestingValidarParametros(){
  const erros=[];
  const fonte=document.getElementById('nest-fonte')?.value||'manual';
  const slabW=nestNum(document.getElementById('nest-slabW').value);
  const slabH=nestNum(document.getElementById('nest-slabH').value);
  const kerfMm=nestNum(document.getElementById('nest-kerf').value);
  const refilo=nestNum(document.getElementById('nest-refilo').value);
  if(fonte==='manual'){
    if(!(slabW>=50&&slabW<=1000)) erros.push('Largura da chapa deve estar entre 50 e 1000 cm.');
    if(!(slabH>=50&&slabH<=1000)) erros.push('Comprimento da chapa deve estar entre 50 e 1000 cm.');
  }
  if(!(kerfMm>=0&&kerfMm<=30)) erros.push('Disco entre 0 e 30 mm.');
  if(!(refilo>=0&&refilo<=10)) erros.push('Refilo entre 0 e 10 cm.');
  if(fonte==='manual'&&refilo*2>=Math.min(slabW,slabH)) erros.push('Refilo maior que a chapa.');
  return {erros,fonte,slabW,slabH,kerf:kerfMm/10,refilo};
}

function renderNestingPlano(){
  if(_nestingPlanoAberto){nestingRenderPlanoSalvo();return;}
  const out=document.getElementById('nest-output');
  const material=document.getElementById('nest-material')?.value||'';
  nestingRenderAcoes();
  const v=nestingValidarParametros();
  const chapasWrap=document.getElementById('nest-chapas-wrap');
  if(chapasWrap)chapasWrap.style.display=v.fonte==='estoque'?'':'none';
  ['nest-slabW','nest-slabH'].forEach(id=>{const el=document.getElementById(id);if(el)el.disabled=v.fonte==='estoque'});
  if(!material){out.innerHTML='<p style="color:var(--muted);padding:20px 0">Selecione um material para gerar o plano.</p>';_nestingCalcAtual=null;return;}
  if(v.erros.length){out.innerHTML=`<div style="background:#fee2e2;border:1px solid #fca5a5;border-radius:8px;padding:12px;color:#b91c1c"><strong>Parâmetros inválidos:</strong><ul style="margin:6px 0 0;padding-left:18px">${v.erros.map(e=>`<li>${e}</li>`).join('')}</ul></div>`;_nestingCalcAtual=null;return;}
  const todas=extrairPecasGlobal(material);
  if(!todas.length){out.innerHTML='<p style="color:var(--muted);padding:20px 0">Nenhuma peça deste material em pedidos aprovados para corte.<br><small>Só entram no plano pedidos com status entre APROVADO e EM CORTE.</small></p>';_nestingCalcAtual=null;return;}
  const espSel=document.getElementById('nest-esp');
  const espessuras=[...new Set(todas.map(p=>p.esp))].sort((a,b)=>a-b);
  const espPrev=nestNum(espSel.value);
  espSel.innerHTML=espessuras.map(e=>`<option value="${e}"${e===espPrev?' selected':''}>${e} cm</option>`).join('');
  const espessura=nestNum(espSel.value)||espessuras[0];
  const pieces=todas.filter(p=>p.esp===espessura);
  if(!pieces.length){out.innerHTML='<p style="color:var(--muted);padding:20px 0">Nenhuma peça nesta espessura.</p>';_nestingCalcAtual=null;return;}
  const veioTravado=(document.getElementById('nest-veio')?.value||'travar')==='travar';
  pieces.forEach(p=>{p.rotatable=!veioTravado;});

  // ---- cálculo: chapas reais do estoque ou dimensões manuais ----
  let slabsUteis=[],overflows=[],chapasReais=[],totalChapaM2=0;
  if(v.fonte==='estoque'){
    const key=material+'|'+espessura;
    if(_nestingChapasKey!==key){_nestingChapasSel=null;_nestingChapasKey=key;}
    const disp=nestingChapasDisponiveis(material,espessura);
    const selecionadas=(_nestingChapasSel instanceof Set)?_nestingChapasSel:new Set(disp.map(c=>c.chapaId));
    renderNestingChapasLista(disp,selecionadas);
    const escolhidas=disp.filter(c=>selecionadas.has(c.chapaId));
    if(!escolhidas.length){out.innerHTML='<div style="background:#fff7ed;border:1px solid #fdba74;border-radius:8px;padding:12px;color:#9a3412">Nenhuma chapa do estoque selecionada. Marque as chapas acima ou mude a origem para "Dimensões manuais".</div>';_nestingCalcAtual=null;return;}
    const r=nestingCalcChapasReais(pieces,escolhidas,v.kerf,v.refilo);
    slabsUteis=r.usadas.map(u=>u.slab);
    chapasReais=r.usadas.map(u=>u.chapa);
    overflows=r.restantes;
    totalChapaM2=chapasReais.reduce((s,c)=>s+c.largura*c.altura/10000,0);
  } else {
    const usableW=v.slabW-2*v.refilo,usableH=v.slabH-2*v.refilo;
    const slabs=nestingCalc(pieces,usableW,usableH,v.kerf);
    overflows=slabs.flatMap(s=>s.placed).filter(p=>p.overflow);
    slabsUteis=slabs.map(s=>({placed:s.placed.filter(p=>!p.overflow),free:s.free||[]})).filter(s=>s.placed.length);
    chapasReais=slabsUteis.map(()=>null);
    totalChapaM2=slabsUteis.length*v.slabW*v.slabH/10000;
  }
  const totalM2=pieces.reduce((s,p)=>s+p.w*p.h/10000,0);
  const effMed=totalChapaM2?(totalM2/totalChapaM2*100):0;
  const idxMap=new Map(pieces.map((p,i)=>[p.id,i+1]));
  const medsPendentes=[...new Set(pieces.filter(p=>p.medicaoId&&!p.medAprovada).map(p=>p.medicaoId))];
  const semDesenho=pieces.filter(p=>p.semDesenho).length;
  const foraEsq=pieces.filter(p=>p.foraEsquadro).length,naoLiberada=pieces.filter(p=>p.naoLiberada).length;
  _nestingCalcAtual={material,espessura,fonte:v.fonte,slabW:v.slabW,slabH:v.slabH,kerf:v.kerf,refilo:v.refilo,veioTravado,escopo:_nestingScope,medicaoId:_nestingScope==='medicao'?_nestingMedicaoId:null,
    pedidoIds:[...new Set(pieces.map(p=>p.pedidoId).filter(Boolean))],pieces,slabs:slabsUteis,chapasReais,overflows,
    aproveitamento:Math.round(effMed*10)/10,totalM2:Math.round(totalM2*1000)/1000,
    assinatura:nestingAssinatura(pieces),origemPendente:medsPendentes.length>0,semDesenho,foraEsq,naoLiberada};
  let html=`<div style="display:flex;gap:16px;flex-wrap:wrap;margin-bottom:14px;padding:10px 14px;background:var(--surface);border-radius:8px;font-size:13px;border:1px solid var(--border)">
    <span>✂️ <strong>${pieces.length}</strong> peças</span>
    <span>💎 <strong>${slabsUteis.length}</strong> chapa(s)${v.fonte==='estoque'?' do estoque':''}</span>
    <span>📐 <strong>${totalM2.toFixed(3)}</strong> m² de peças</span>
    <span>🟩 <strong>${effMed.toFixed(1)}%</strong> aproveitamento</span>
    <span>${veioTravado?'🧭 veio travado, sem rotação':'↻ rotação livre (material sem veio)'}</span>
    <span style="color:var(--muted)">${escapeHtml(material)} · ${espessura} cm</span>
  </div>`;
  const avisos=[];
  if(medsPendentes.length) avisos.push(`Medição de origem <strong>ainda não aprovada tecnicamente</strong> (${medsPendentes.length}). Aprove a medição antes de aprovar o plano.`);
  if(semDesenho) avisos.push(`${semDesenho} peça(s) <strong>sem desenho técnico detalhado</strong> — conferir medidas antes do corte.`);
  if(naoLiberada) avisos.push(`${naoLiberada} peça(s) <strong>sem liberação técnica individual</strong> — o plano pode ser conferido, mas não pode ser aprovado para corte.`);
  if(foraEsq) avisos.push(`${foraEsq} peça(s) <strong>fora de esquadro</strong> — já dimensionadas com sobremedida; conferir no desenho.`);
  if(avisos.length) html+=`<div style="background:#fff7ed;border:1px solid #fdba74;border-radius:8px;padding:10px 14px;margin-bottom:12px;font-size:12px;color:#9a3412"><strong>⚠ Atenção:</strong><ul style="margin:6px 0 0;padding-left:18px">${avisos.map(a=>`<li>${a}</li>`).join('')}</ul></div>`;
  slabsUteis.forEach((slab,i)=>{
    const ch=chapasReais[i];
    const cw=ch?ch.largura:v.slabW,chh=ch?ch.altura:v.slabH;
    const info=ch?`Nº ${escapeHtml(String(ch.numero))}${ch.retalho?' · RETALHO':''} · estoque`:'';
    html+=nestingSvgRender(slab,cw,chh,v.kerf,v.refilo,i,idxMap,veioTravado,info);
  });
  if(overflows.length){
    html+=`<div style="background:#fee2e2;padding:12px;border-radius:8px;border:1px solid #fca5a5;margin-top:8px"><strong style="color:#dc2626">⛔ ${overflows.length} peça(s) NÃO ALOCADAS, não estão desenhadas em nenhuma chapa:</strong><ul style="margin:8px 0 0;padding-left:18px;font-size:12px">`;
    overflows.forEach(p=>{html+=`<li><strong>${escapeHtml(p.nome)}</strong> (P.${escapeHtml(String(p.pedidoNum||'?'))} · ${escapeHtml(p.cliente||'')}) — ${p.w}×${p.h} cm. Opções: ${v.fonte==='estoque'?'selecionar mais chapas, ':''}chapa maior, emenda planejada ou revisão da medida.</li>`;});
    html+=`</ul></div>`;
  }
  html+=nestingChecklistHtml();
  out.innerHTML=html;
  nestingRenderBanner(null);
}

function nestingChecklistHtml(){
  const c=_nestingCalcAtual||{};
  return `<div class="nesting-checklist" style="margin-top:14px;border:1.5px solid #334155;border-radius:8px;padding:12px 14px;font-size:12px;background:#f8fafc;color:#0f172a">
    <strong style="font-size:13px">CONFERÊNCIA OBRIGATÓRIA ANTES DO CORTE</strong>
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(230px,1fr));gap:4px 18px;margin-top:8px">
      <label>☐ Material confere: <strong>${escapeHtml(c.material||'—')}</strong></label>
      <label>☐ Espessura confere: <strong>${c.espessura||'—'} cm</strong></label>
      <label>☐ Sentido do veio conferido ${c.veioTravado?'(TRAVADO no plano)':'(rotação livre)'}</label>
      <label>☐ Chapa separada e identificada ${c.fonte==='estoque'?'(números no plano)':'(nº ____________)'}</label>
      <label>☐ Medidas das peças conferidas com o desenho técnico</label>
      <label>☐ Recortes, cubas e furos conferidos</label>
      <label>☐ Disco/kerf ajustado: ${((c.kerf||0)*10).toFixed(0)} mm · refilo ${c.refilo??'—'} cm</label>
      <label>☐ Sobras identificadas e etiquetadas após o corte</label>
    </div>
    <div style="display:flex;gap:40px;margin-top:16px">
      <span style="border-top:1px solid #64748b;padding-top:3px;flex:1;text-align:center">Conferente / produção</span>
      <span style="border-top:1px solid #64748b;padding-top:3px;flex:1;text-align:center">Cortador</span>
      <span style="border-top:1px solid #64748b;padding-top:3px;flex:1;text-align:center">Data / hora</span>
    </div>
  </div>`;
}

function nestingSvgRender(slab,slabW,slabH,kerf,refilo,slabIdx,idxMap,veioTravado,chapaInfo){
  const SVGW=880,PAD=44;
  const scale=(SVGW-PAD*2-24)/slabW;
  const dispW=slabW*scale,dispH=slabH*scale;
  const svgH=dispH+PAD*2+30;
  const OX=PAD,OY=PAD+2;
  const rf=refilo*scale;
  const COLS={tampo:{f:'#ede9fe',s:'#7c3aed'},saia:{f:'#d1fae5',s:'#059669'},rodabanca:{f:'#ffedd5',s:'#d97706'},pe:{f:'#e0f2fe',s:'#0369a1'},default:{f:'#f1f5f9',s:'#64748b'}};
  const usedArea=slab.placed.reduce((s,p)=>s+p.pw*p.ph,0);
  const eff=(usedArea/(slabW*slabH)*100).toFixed(1);
  const sobras=nestingSobras(slab);
  let s=`<section class="nesting-sheet">`;
  s+=`<svg viewBox="0 0 ${SVGW} ${svgH}" xmlns="http://www.w3.org/2000/svg" style="display:block;width:100%;border:1px solid #e2e8f0;border-radius:8px 8px 0 0;background:#fff">`;
  s+=`<rect x="0" y="0" width="${SVGW}" height="28" fill="#1e293b" rx="8"/>`;
  s+=`<text x="${OX}" y="18" font-size="12" font-weight="700" fill="#f8fafc">CHAPA ${slabIdx+1}${chapaInfo?` · ${chapaInfo}`:''}</text>`;
  s+=`<text x="${OX+(chapaInfo?260:72)}" y="18" font-size="11" fill="#94a3b8">${slabW}×${slabH} cm · disco ${(kerf*10).toFixed(0)} mm · refilo ${refilo} cm · ${slab.placed.length} peça(s) · ${eff}% aproveitamento</text>`;
  if(veioTravado) s+=`<text x="${SVGW-8}" y="18" text-anchor="end" font-size="11" fill="#fbbf24">⟶ SENTIDO DO VEIO (rotação travada)</text>`;
  s+=`<defs><pattern id="h${slabIdx}" patternUnits="userSpaceOnUse" width="10" height="10"><line x1="0" y1="10" x2="10" y2="0" stroke="#cbd5e1" stroke-width="1"/></pattern></defs>`;
  s+=`<rect x="${OX}" y="${OY}" width="${dispW.toFixed(1)}" height="${dispH.toFixed(1)}" fill="url(#h${slabIdx})" stroke="#64748b" stroke-width="1.5"/>`;
  if(refilo>0) s+=`<rect x="${(OX+rf).toFixed(1)}" y="${(OY+rf).toFixed(1)}" width="${(dispW-2*rf).toFixed(1)}" height="${(dispH-2*rf).toFixed(1)}" fill="none" stroke="#94a3b8" stroke-width="1" stroke-dasharray="6 4"/>`;
  slab.placed.forEach(p=>{
    const lNum=idxMap.get(p.id)||'?';
    const c=COLS[p.tipo]||COLS.default;
    const px=(OX+rf+p.px*scale).toFixed(1),py=(OY+rf+p.py*scale).toFixed(1);
    const pw=(p.pw*scale).toFixed(1),ph=(p.ph*scale).toFixed(1);
    const cx=parseFloat(px)+parseFloat(pw)/2,cy=parseFloat(py)+parseFloat(ph)/2;
    s+=`<rect x="${px}" y="${py}" width="${pw}" height="${ph}" fill="${c.f}" stroke="${c.s}" stroke-width="1.5" rx="2"/>`;
    const numFs=Math.max(9,Math.min(20,parseFloat(pw)/4,parseFloat(ph)/2.5));
    s+=`<text x="${cx.toFixed(1)}" y="${(cy+1).toFixed(1)}" text-anchor="middle" dominant-baseline="middle" font-size="${numFs.toFixed(0)}" font-weight="700" fill="${c.s}" opacity="0.9">${lNum}</text>`;
    if(parseFloat(pw)>32&&parseFloat(ph)>20){
      s+=`<text x="${(parseFloat(px)+3).toFixed(1)}" y="${(parseFloat(py)+9).toFixed(1)}" font-size="7" fill="${c.s}" opacity="0.8">P.${escapeHtml(String(p.pedidoNum||'—'))}${p.rotated?' ↻':''}${p.foraEsquadro?' ⚠':''}</text>`;
    }
    if(parseFloat(pw)>30) s+=`<text x="${cx.toFixed(1)}" y="${(parseFloat(py)-3).toFixed(1)}" text-anchor="middle" font-size="7.5" fill="${c.s}">${p.pw.toFixed(0)}</text>`;
    if(parseFloat(ph)>22) s+=`<text x="${(parseFloat(px)-3).toFixed(1)}" y="${cy.toFixed(1)}" text-anchor="end" dominant-baseline="middle" font-size="7.5" fill="${c.s}">${p.ph.toFixed(0)}</text>`;
  });
  const cotaY=(OY+dispH+10).toFixed(1);
  s+=`<line x1="${OX}" y1="${cotaY}" x2="${(OX+dispW).toFixed(1)}" y2="${cotaY}" stroke="#475569" stroke-width="1"/>`;
  s+=`<line x1="${OX}" y1="${(parseFloat(cotaY)-4).toFixed(1)}" x2="${OX}" y2="${(parseFloat(cotaY)+4).toFixed(1)}" stroke="#475569"/>`;
  s+=`<line x1="${(OX+dispW).toFixed(1)}" y1="${(parseFloat(cotaY)-4).toFixed(1)}" x2="${(OX+dispW).toFixed(1)}" y2="${(parseFloat(cotaY)+4).toFixed(1)}" stroke="#475569"/>`;
  s+=`<text x="${(OX+dispW/2).toFixed(1)}" y="${(parseFloat(cotaY)+14).toFixed(1)}" text-anchor="middle" font-size="11" fill="#475569">${slabW} cm</text>`;
  const cotaX=(OX+dispW+10).toFixed(1);
  s+=`<line x1="${cotaX}" y1="${OY}" x2="${cotaX}" y2="${(OY+dispH).toFixed(1)}" stroke="#475569" stroke-width="1"/>`;
  s+=`<text x="${(parseFloat(cotaX)+16).toFixed(1)}" y="${(OY+dispH/2).toFixed(1)}" text-anchor="middle" dominant-baseline="middle" font-size="11" fill="#475569" transform="rotate(90 ${(parseFloat(cotaX)+16).toFixed(1)} ${(OY+dispH/2).toFixed(1)})">${slabH} cm</text>`;
  s+=`</svg>`;
  s+=`<table style="width:100%;border-collapse:collapse;font-size:11px;border:1px solid #e2e8f0;border-top:none">`;
  s+=`<thead><tr style="background:#f8fafc"><th style="padding:5px 8px;text-align:center;width:36px;border-bottom:1px solid #e2e8f0">#</th><th style="padding:5px 8px;text-align:left;border-bottom:1px solid #e2e8f0">Tipo</th><th style="padding:5px 8px;text-align:left;border-bottom:1px solid #e2e8f0">Pedido</th><th style="padding:5px 8px;text-align:left;border-bottom:1px solid #e2e8f0">Cliente</th><th style="padding:5px 8px;text-align:left;border-bottom:1px solid #e2e8f0">Ambiente</th><th style="padding:5px 8px;text-align:left;border-bottom:1px solid #e2e8f0">Peça</th><th style="padding:5px 8px;text-align:right;border-bottom:1px solid #e2e8f0">Corte (cm)</th><th style="padding:5px 8px;text-align:right;border-bottom:1px solid #e2e8f0">m²</th></tr></thead><tbody>`;
  slab.placed.forEach(p=>{
    const lNum=idxMap.get(p.id)||'?';
    const c=COLS[p.tipo]||COLS.default;
    const tipoLabel={'tampo':'Tampo','saia':'Saia','rodabanca':'Rodabanca','pe':'Pé de pedra'}[p.tipo]||p.tipo;
    const flags=`${p.rotated?' ↻ girada':''}${p.foraEsquadro?' ⚠ fora de esquadro':''}${p.engaste?` +${p.engaste}cm engaste`:''}${p.semDesenho?' ▲ sem desenho':''}${p.naoLiberada?' ⛔ não liberada':''}`;
    s+=`<tr${p.foraEsquadro||p.semDesenho||p.naoLiberada?' style="background:#fffbeb"':''}><td style="padding:4px 8px;text-align:center;font-weight:700;color:${c.s}">${lNum}</td><td style="padding:4px 8px;color:${c.s}">${tipoLabel}${flags}</td><td style="padding:4px 8px">P.${escapeHtml(String(p.pedidoNum||'—'))}</td><td style="padding:4px 8px">${escapeHtml(p.cliente||'—')}</td><td style="padding:4px 8px">${escapeHtml(p.ambiente||'—')}</td><td style="padding:4px 8px">${escapeHtml(p.nome||'—')}${p.uid?` <span style="color:#94a3b8;font-family:monospace;font-size:9px">${escapeHtml(p.uid)}</span>`:''}</td><td style="padding:4px 8px;text-align:right;font-family:monospace">${p.pw.toFixed(1)}×${p.ph.toFixed(1)}</td><td style="padding:4px 8px;text-align:right;font-family:monospace">${(p.w*p.h/10000).toFixed(4)}</td></tr>`;
  });
  s+=`</tbody></table>`;
  if(sobras.length) s+=`<div style="border:1px solid #e2e8f0;border-top:none;border-radius:0 0 8px 8px;padding:6px 10px;font-size:11px;background:#f0fdf4;color:#166534"><strong>Sobras aproveitáveis desta chapa (até):</strong> ${sobras.map(r=>`${r.w}×${r.h} cm`).join(' · ')} — etiquetar e guardar como retalho.</div>`;
  s+=`</section>`;
  return s;
}

// ---------------------------------------------------
